export default "__VITE_ASSET__CfvGFp69__"